// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProgressBar__tooltip___3W2g-{transform:translateY(0)!important}.ProgressBar__tooltip___3W2g->span:nth-child(2){border-width:4px 4px 0}.ProgressBar__ProgressBarContainer___3y3vX{z-index:15000}@media (forced-colors: active){.ProgressBar__progressBarHC___1371d{background-color:ButtonText!important}}", ""]);
// Exports
exports.locals = {
	"tooltip": "ProgressBar__tooltip___3W2g-",
	"ProgressBarContainer": "ProgressBar__ProgressBarContainer___3y3vX",
	"progressBarHC": "ProgressBar__progressBarHC___1371d"
};
module.exports = exports;
